// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"232":"PageHome","650":"PageMarketDetail","810":"PageWelcome","975":"PagePositions"}[chunkId] || chunkId) + "." + {"158":"95edff1a","232":"22287a15","650":"7765b980","810":"828723c1","975":"adfaf906"}[chunkId] + ".chunk.css";
};